import { render, staticRenderFns } from "./favoritebutton.vue?vue&type=template&id=0ce8842e&"
import script from "./favoritebutton.vue?vue&type=script&lang=ts&"
export * from "./favoritebutton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Thermotech\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ce8842e')) {
      api.createRecord('0ce8842e', component.options)
    } else {
      api.reload('0ce8842e', component.options)
    }
    module.hot.accept("./favoritebutton.vue?vue&type=template&id=0ce8842e&", function () {
      api.rerender('0ce8842e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Dev/js/components/products/favoritebutton.vue"
export default component.exports